import {getScales} from "@/http/services/http-services-print";
import {blockUi, unblockUi} from "@/modules/elements-blockui";
import {addHtmlBySelector, hideElementsBySelector, removeElementBySelector} from "@/helpers/element-helper";
import {removeLayer, removeLayersIncludes} from "@/helpers/ol/ol-layer-helper";
import {Select, Translate} from "ol/interaction";
import {pointerMove} from "ol/events/condition";
import {Fill, Stroke, Style} from "ol/style";
import CircleStyle from "ol/style/Circle";
import {getViewRotation, viewFit} from "@/helpers/ol/ol-view";
import {Feature} from "ol";
import {Polygon} from "ol/geom";
import {transform} from "ol/proj";
import VectorSource from "ol/source/Vector";
import VectorLayer from "ol/layer/Vector";
import {generatePrintLegends} from "@/helpers/layer/info/layer-info-legend-helper";
import {getViewProjectionName} from "@/helpers/ol/ol-projection-helper";
import $ from "jquery";

let polygon
let feature
let scale
let layouts
let layout
let select
let translate
let printLayer

const selector = '.info-menu-content'
const INCHES_PER_UNIT = {
    'm': 39.37,
    'dd': 4374754
};
const DOTS_PER_INCH = 72;

export function initPrint(template = undefined) {

    window.printTemplate = template
    blockUi(selector, 0.5)

    removeLayersIncludes('print-select-layer-item-')
    getScales(template).then( result => {

        window.printScales = result

        removeElementBySelector('bookmark-print')
        addHtmlBySelector(selector, '<bookmark-print class="layer-info-block"></bookmark-print>')

        const resolution = window.map.getView().getResolution()
        const units = map.getView().getProjection().getUnits();
        const scaleFromResolution = getScaleFromResolution(resolution, 'm')

        layouts = result.layouts
        const scales = []
        layouts[0].scales.map( (scale) => {
            scales.push(scale.value)
        })

        window.printLayout = layouts[0]

        const value = scales.reduce((a, b) => {
            return Math.abs(b - scaleFromResolution) < Math.abs(a - scaleFromResolution) ? b : a;
        })

        $("#slcPrintScale").val(value).trigger('change');

        printAddRectangle()

        unblockUi(selector)
    })
}

export function updateLayout() {

}

export function clearPrint() {
    removeLayer('print', false)
}

export function printAddRectangle() {

    clearPrint()

    const slcPrintLayout = document.getElementById('slcPrintLayout')
    if(!slcPrintLayout) {
        return;
    }

    layout = slcPrintLayout.value
    scale = document.getElementById('slcPrintScale').value

    const layoutObject = layouts.find( layoutItem => layoutItem.name === layout)
    const width = layoutObject.map.width
    const height = layoutObject.map.height

    const w = width * scale * 0.00035273
    const h = height * scale * 0.00035273

    const center = window.map.getView().getCenter()
    const points = [];

    points[0] =[center[0] - w / 2, center[1] - h / 2];
    points[1] = [center[0] + w / 2, center[1] - h / 2];
    points[2] = [center[0] + w / 2, center[1] + h / 2];
    points[3] = [center[0] - w / 2, center[1] + h / 2];
    points[4] = [center[0] - w / 2, center[1] - h / 2];

    const vectorSource = new VectorSource()
    printLayer = new VectorLayer({
        altitudeMode: 'clampToGround',
        name: 'print',
        source: vectorSource,
        style: getPrintVectorLayerStyle(),
        zIndex: 1000,
    });

    points.map((point, key) => {
        points[key] = point
    })

    polygon = new Polygon([points]);

    const rotateAngle = getViewRotation();
    polygon.rotate( rotateAngle, window.map.getView().getCenter());

    feature = new Feature({
        name: "Thing",
        geometry: polygon
    });
    vectorSource.addFeature(feature)

    let padding = [100, 200, 100, 200]
    if(width > height) {
        padding = [100, 300, 100, 400]
    }

    viewFit(
        feature.getGeometry(),
        padding,
        undefined,
        2000
    )

    window.map.addLayer(printLayer)

    if(select !== undefined) {
        window.map.removeInteraction(select);
        window.map.removeInteraction(translate);
    }

    select = new Select({
        condition: pointerMove,
        style: getPrintVectorLayerStyle(),
        layers: [printLayer]
    });

    translate = new Translate({
        features: select.getFeatures(),
    });

    // Hide download button when changing print area
    translate.on('translating', () => {
        hideElementsBySelector('#btnPrintDownloadPDF')
    })

    window.map.addInteraction(select);
    window.map.addInteraction(translate);

    generatePrintLegends()
}

/**
 * @param {number} resolution Resolution.
 * @param {string} units Units
 * @return {number} Scale
 */
export function getScaleFromResolution(resolution, units) {
    var scale = INCHES_PER_UNIT[units] * DOTS_PER_INCH * resolution;
    // if (opt_round) {
    scale = Math.round(scale);
    // }
    return scale;
}

export function getPrintSettings() {
    const printSettings = {}
    printSettings.feature = feature
    printSettings.scale = scale
    printSettings.layout = layout

    return printSettings
}

export function getPrintVectorLayerStyle(opacity = 0.1) {
    return new Style({
        fill: new Fill({
            color: 'rgba(2, 188, 119, ' + opacity + ')',
        }),
        stroke: new Stroke({
            color: '#02bc77',
            width: 2,
        }),
        image: new CircleStyle({
            radius: 7,
            fill: new Fill({
                color: '#02bc77',
            }),
        }),
    })
}

export function getPrintStyle() {
    return {
        strokeColor: '#ffd939',
        strokeOpacity: 1,
        strokeWidth: 2,
        fillColor: '#ffd939',
        fillOpacity: 0.3,
    }
}

export function getPrintLayer() {
    return printLayer
}
